/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["canvas[_ngcontent-%COMP%]{max-width:80%;max-height:100%}[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;padding-right:0;height:100;max-height:100%;height:calc(100vh - 200px)}.icon[_ngcontent-%COMP%]{color:gray;font-size:32px;cursor:pointer}.icon[_ngcontent-%COMP%]:hover{color:#007bff}\n/*# sourceMappingURL=image-slide.component.css.map*/"];
export { styles as styles };
